// extracted by mini-css-extract-plugin
export default {"btop":"a1c66655bb _7a12301bfd _9546daa876","icon":"c6075f4168 _0859b87fe2","btoppink":"_03371e0670 _631235a0f9"};